<template>
  <a-layout>
    <a-layout-content>
      <a-page-header @back="this.goBack" class="vd-gl-header-warp"
                     :title="this.$route.meta.title"
                     :sub-title="this.$route.meta.subTitle"/>
      <div class="vd-gl-content">
        <!-- 检索条件 -->
        <a-row class="vd-toolbar">
          <a-col class="vd-bar">
            <a-form layout="inline">
              <a-form-item>
                <a-tooltip title="群号">
                  <a-input class="vd-input-xs" placeholder="群号" v-model="form.groupQq"/>
                </a-tooltip>
              </a-form-item>
              <a-form-item>
                <a-tooltip title="负责人工号">
                  <a-input class="vd-input-xs" placeholder="负责人工号" v-model="form.code"/>
                </a-tooltip>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
        <!-- 内容主体 -->
        <a-table :data-source="list" row-key="id" size="small"
                 :loading="loading" :pagination="pagination">
          <a-table-column title="ID" data-index="id"/>
          <a-table-column title="群号" data-index="group_qq"/>
        </a-table>

      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>

  export default {
    name: 'Index',
    data () {
      return {
        loading: false,
        areaList: [],
        areaTree: [],
        subList: [],
        list: [],
        form: {
          groupQq: '',
          code: '',
          loginQq: undefined,
          areaPath: [],
          category: undefined,
          newLoginQq: undefined,
        },
        pagination: {
          current: 1,
          total: 0,
          pageSize: 15,
          hideOnSinglePage: true,
          showTotal: total => `总共 ${total} 条`,
          onChange: page => {
            this.pagination.current = page
            this.getData()
          },
        },
      }
    },
    created () {
      this.getData()
    },
    methods: {
      // 获取活动详情
      detail (e) {
        this.$router.push({
          path: '/qq/detail',
          query: { id: e.id },
        })
      },
      // 获取数据
      getData () { },
      // 搜索条件重置
      searchRedo () {
        this.pagination.current = 1
        this.form.groupQq = ''
        this.form.code = ''
        this.form.loginQq = undefined
        this.form.category = undefined
        this.form.areaPath = []

        this.getData()
      },
      // 搜索数据
      searchInfo () {
        this.pagination.current = 1
        this.getData()
      },
      // 修改数据
      modify (record) {
        this.visible = !this.visible
        this.qqForm.id = record.id
        if (!this.$HelperUtil.isEmpty(record.area_path)) {
          let path = record.area_path.split(',')
          path = path.map(data => {
            return +data
          })
          this.qqForm.areaPath = path
        } else {
          this.qqForm.areaPath = record.area_path
        }
        this.qqForm.category = record.category_id === 0 ? undefined : record.category_id
      },
      // 提交数据
      qqConfirm () {
      },
      // 取消提交数据
      qqCancel () {
        this.visible = !this.visible
        // 数据清除
        this.qqForm.id = this.qqForm.area = this.qqForm.category = undefined
        this.qqForm.areaPath = []
      },
    },
  }
</script>

<style scoped>

</style>